// src/components/Contact.js
import React, { useState } from 'react';
import './Contact.css'; // Assurez-vous que ce fichier CSS est créé

function Contact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Construction de la chaîne de requête mailto
        const mailtoString = `mailto:yuzult_app@gmail.com?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent('Nom: ' + formData.name + '\nEmail: ' + formData.email + '\nMessage: ' + formData.message)}`;
        
        // Redirection vers le client de messagerie par défaut
        window.location.href = mailtoString;
    };

    return (
        <div className="contact-container">
            <h1>Contact Us</h1>
            <form onSubmit={handleSubmit}>
                <input 
                    type="text" 
                    name="name" 
                    placeholder="Your name" 
                    value={formData.name} 
                    onChange={handleChange} 
                />
                <input 
                    type="email" 
                    name="email" 
                    placeholder="Your email" 
                    value={formData.email} 
                    onChange={handleChange} 
                />
                <input 
                    type="text" 
                    name="subject" 
                    placeholder="Subject" 
                    value={formData.subject} 
                    onChange={handleChange} 
                />
                <textarea 
                    name="message" 
                    placeholder="Your message" 
                    value={formData.message} 
                    onChange={handleChange}
                />
                <button type="submit">Send</button>
            </form>
        </div>
    );
    
}

export default Contact;



// // src/components/Contact.js
// import React, { useState } from 'react';
// import './Contact.css'; // Assurez-vous de créer ce fichier CSS

// function Contact() {
//     const [formData, setFormData] = useState({
//         name: '',
//         email: '',
//         message: ''
//     });

//     const handleChange = (e) => {
//         setFormData({ ...formData, [e.target.name]: e.target.value });
//     };

//     const handleSubmit = (e) => {
//         e.preventDefault();
//         // Traitement pour l'envoi de l'email ici
//         console.log(formData);
//         // Vous pouvez utiliser un service comme EmailJS ou une API backend pour envoyer l'email
//     };

//     return (
//         <div className="contact-container">
//             <h1>Contactez-nous</h1>
//             <form onSubmit={handleSubmit}>
//                 <input 
//                     type="text" 
//                     name="name" 
//                     placeholder="Votre nom" 
//                     value={formData.name} 
//                     onChange={handleChange} 
//                 />
//                 <input 
//                     type="email" 
//                     name="email" 
//                     placeholder="Votre email" 
//                     value={formData.email} 
//                     onChange={handleChange} 
//                 />
//                 <textarea 
//                     name="message" 
//                     placeholder="Votre message" 
//                     value={formData.message} 
//                     onChange={handleChange}
//                 />
//                 <button type="submit">Envoyer</button>
//             </form>
//         </div>
//     );
// }

// export default Contact;
